const TASK_MAX_MS = 6;

const yieldFn = window.scheduler
    ? window.scheduler.yield.bind(window.scheduler)
    : () => new Promise(window.requestAnimationFrame);

export const cooperateWhile = async (
    condition: () => boolean,
    run: () => void,
) => {
    let start = performance.now();
    let iterations = 0;

    while (condition()) {
        run();

        if (performance.now() - start > TASK_MAX_MS) {
            await yieldFn();
            start = performance.now();
            iterations++;
        }
    }

    return iterations;
};
